import axios from "axios";
import HttpHelper from "../helper/HttpHelper";

class HobbyistAverageService {
  getAll(payload) {
    return axios.get(
      HttpHelper.API_URL + "/hobbyist-averages",
      { params: payload },
      HttpHelper.getHeader()
    );
  }

  getOne(id, payload) {
    return axios.get(
      HttpHelper.API_URL + "/hobbyist-averages/" + id,
      { params: payload },
      HttpHelper.getHeader()
    );
  }

  create(payload) {
    return axios.post(
      HttpHelper.API_URL + "/hobbyist-averages",
      payload,
      HttpHelper.getAuthHeader()
    );
  }

  update(id, payload) {
    return axios.put(
      HttpHelper.API_URL + "/hobbyist-averages/" + id,
      payload,
      HttpHelper.getAuthHeader()
    );
  }

  delete(id) {
    return axios.delete(
      HttpHelper.API_URL + "/hobbyist-averages/" + id,
      HttpHelper.getAuthHeader()
    );
  }
}

export default HobbyistAverageService = new HobbyistAverageService();
